/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import $ from "jquery";
import { Select, TextInput } from "react-materialize";
import Html from "../../utils/Html";
import Func from "../../utils/Func";
import FilterDivisionOneSelect from "./FilterDivisionOneSelect";
import FilterDepartmentOneSelect from "./FilterDepartmentOneSelect";

export default function TopContent({
  userData,
  filterData,
  filters,
  setFilters }) {
  function getDeptById(allDivisions, deptId) {
    return (
      Object.values(allDivisions)
        .flat()
        .find((dept) => dept.dept_id === deptId) || null
    );
  }

  const handleEvents = {
    FilterDate: {
      OnChangeEndDate: function (evt) {
        let elem = $(evt.target);
        const startDate = $("#filter-inp-start-date").val();
        const maxEndDate = Func.GetEndDate(startDate);
        const endDate = elem.val();
        const d1 = new Date(maxEndDate);
        const d2 = new Date(endDate);
        const helper = $("#helper-text-end-date");
        if (d2 > d1) {
          helper.removeClass("hide");
          $("#filter-inp-end-date").val(maxEndDate).attr("value", maxEndDate);
        } else {
          helper.addClass("hide");
        }
      },
      OnChangeStartDate: function (evt) {
        let elem = $(evt.target);
        const startDate = elem.val();
        const endDate = Func.GetEndDate(startDate);
        $("#filter-inp-end-date").val(endDate).attr("value", endDate);
      } },
    FilterCountry: {
      OnChange: function (evt) {
        const country = $(evt.target).val();
        let userDept = [];
        // userDept = Func.getDeptIdsByCountryAndUser(
        //   filterData.departments ?? [],
        //   [country],
        //   userData.user_only_dept ?? []
        // );
        let userDivs = [];
        // if (userDept.length > 0) {
        //   userDivs = Func.getValuesByParent(
        //     filterData.divisions ?? [],
        //     userDept,
        //     userData.user_only_divs ?? []
        //   );
        // }
        setFilters((prev) => ({
          ...prev,
          country: [country],
          department: userDept,
          division: userDivs,
          key_form: Func.GetKeyRandom() }));
      } },
    // FilterDepartment: {
    //   OnChange: function (evt) {
    //     const departments = $(evt.target).val();
    //     const divisions = Func.getValuesByParent(
    //       filterData.divisions ?? [],
    //       departments,
    //       "dept_id"
    //     );
    //     setFilters((prev) => ({
    //       ...prev,
    //       department: departments,
    //       division: divisions,
    //       key_form: Func.GetKeyRandom(),
    //     }));
    //   },
    // },
    // FilterDivision: {
    //   OnChange: function (evt) {
    //     const id = Number(evt.target.value); // แปลงเป็น number ให้ตรงกับ dept_id
    //     console.log("checked id =", id);
    //     const isChecked = evt.target.checked;

    //     // เก็บเฉพาะรายการ id ที่เลือกไว้ใน state
    //     const selectedIds = filters.division ?? [];

    //     // ป้องกันซ้ำ และเอาออกเมื่อ uncheck
    //     let nextIds;
    //     if (isChecked) {
    //       nextIds = selectedIds.includes(id)
    //         ? selectedIds
    //         : [...selectedIds, id];
    //     } else {
    //       nextIds = selectedIds.filter((v) => v !== id);
    //     }

    //     // แปลง id → object (ตามที่ขอ: pass dept_id แล้ว return object)
    //     const selectedDivs = getDeptById(filterData.divisions ?? [], id);

    //     console.log("checked id =", id);
    //     console.log("nextIds =", nextIds);
    //     console.log("filterData.division =", filterData.divisions);
    //     console.log("selectedDivs =", selectedDivs);

    //     // setFilters((prev) => ({
    //     //   ...prev,
    //     //   division: nextIds, // ถ้าจะเก็บเฉพาะ id
    //     //   // divisionRows: selectedDepts, // ถ้าต้องการ object ที่เลือกด้วย
    //     // }));
    //   },
    // },
    FilterDepartmentOneSelect: {
      OnChange: function ({ target }) {
        setFilters((prev) => ({
          ...prev,
          [target.name]: target.value, // อัปเดตค่า filter ที่เปลี่ยน
        }));
      } },
    FilterDivisionOneSelect: {
      OnChange: function ({ target }) {
        // setFilters((prev) => ({
        //   ...prev,
        //   [target.name]: target.value, // อัปเดตค่า filter ที่เปลี่ยน
        // }));
        // const rawValues = Array.isArray(target.value)
        //   ? target.value
        //   : typeof target.value === "string"
        //   ? [target.value]
        //   : [];
        // const prevDivisions = filters.division?.map(String) ?? [];
        // const newDivisions = rawValues.map(String);
        // // ✅ หาค่าที่ user เพิ่งเลือก
        // const lastSelected = newDivisions.find(
        //   (v) => !prevDivisions.includes(v)
        // );
        // console.log("lastSelected =", lastSelected);
      } },

    FormFilter: {
      OnSubmit: function (evt) {
        evt.preventDefault();
      } } };

  return (
    <div id="top-content">
      <form
        key={"form-filter-request" + (filters.key_form || 0)}
        id="form-filter-request"
        method="post"
        onSubmit={handleEvents.FormFilter.OnSubmit}
      >
        <div className="row" style={{ marginBottom: 0 }}>
          <div className="col s12 m3">
            <Feature.FilterCountry
              data={filterData.countries}
              filters={filters}
              handleEvents={handleEvents.FilterCountry}
            />
          </div>
          <div className="col s12 m3">
            <Feature.FilterLocation
              data={filterData.locations}
              filters={filters}
              userData={userData}
            />
          </div>
          <div className="col s12 m3">
            <Feature.FilterDepartmentOneSelect
              data={{
                departments: filterData.departments,
                divisions: filterData.divisions }}
              filters={filters}
              userData={userData}
              handleEvents={handleEvents.FilterDepartmentOneSelect}
            />
          </div>
          <div className="col s12 m3">
            <Feature.FilterDivisionOneSelect
              data={{
                departments: filterData.departments,
                divisions: filterData.divisions }}
              filters={filters}
              userData={userData}
              handleEvents={handleEvents.FilterDivisionOneSelect}
            />
          </div>
        </div>

        <div className="row" style={{ marginBottom: "10px" }}>
          <div className="col s12 m3">
            <Feature.FilterLeaveType
              data={filterData.leavetypes}
              filters={filters}
            />
          </div>
          <div className="col s12 m3">
            <Feature.FilterStatus
              data={filterData.statuses}
              filters={filters}
            />
          </div>
          <div className="col s12 m3">
            <Feature.FilterDuration
              data={filterData.durations}
              filters={filters}
            />
          </div>
        </div>

        <div className="row">
          <div className="col s12 m3">
            <Feature.FilterEmail filters={filters} />
          </div>
          <div className="col s12 m3">
            <Feature.FilterName filters={filters} />
          </div>
          <div className="col s12 m3">
            <Feature.FilterStartDate
              filters={filters}
              handleEvents={handleEvents.FilterDate}
            />
          </div>
          <div className="col s12 m3">
            <Feature.FilterEndDate
              filters={filters}
              handleEvents={handleEvents.FilterDate}
            />
          </div>
        </div>

        {/* <div className="filter-inputs row">
        </div> */}
      </form>
    </div>
  );
}

const Feature = {};
Feature.FilterStartDate = ({ filters, handleEvents }) => {
  const startDate =
    "start_date" in filters ? filters["start_date"][0] : Func.GetStartDate();
  return (
    <div key="filter-start-date" className="filter-input-field">
      <TextInput
        id="filter-inp-start-date"
        name="start_date"
        label="Custom Start Date"
        type="date"
        defaultValue={startDate}
        onChange={handleEvents.OnChangeStartDate}
      />
      <span
        className="select-helper-text hide"
        id="helper-text-start-date"
        style={{ width: "160px" }}
      >
        Please input start date
      </span>
    </div>
  );
};
Feature.FilterEndDate = ({ filters, handleEvents }) => {
  const startDate =
    "start_date" in filters ? filters["start_date"][0] : Func.GetStartDate();
  const endDate =
    "end_date" in filters ? filters["end_date"][0] : Func.GetEndDate(startDate);
  return (
    <div
      key="filter-end-date"
      id="filter-end-date"
      className="filter-input-field"
    >
      <TextInput
        id="filter-inp-end-date"
        name="end_date"
        label="Custom End Date"
        type="date"
        defaultValue={endDate}
        onChange={handleEvents.OnChangeEndDate}
      />
      <span
        className="select-helper-text hide"
        id="helper-text-end-date"
        style={{ width: "160px" }}
      >
        Custom date range search will be limited to 12 months date range
      </span>
    </div>
  );
};
Feature.FilterDuration = ({ data, filters }) => {
  return (
    <div key="filter-duration" className="filter-input-field select">
      <Select
        multiple={true}
        id="filter-inp-duration"
        name="duration"
        options={{
          classes: "",
          dropdownOptions: {
            alignment: "left",
            autoTrigger: true,
            closeOnClick: false,
            constrainWidth: true,
            coverTrigger: true,
            hover: false,
            inDuration: 150,
            onCloseEnd: null,
            onCloseStart: null,
            onOpenEnd: null,
            onOpenStart: null,
            outDuration: 250 } }}
        value={filters.duration ?? []}
      >
        <Html.Options
          data={data}
          addon={{
            key: "duration",
            name: "name",
            value: "code",
            title: "Duration" }}
        />
      </Select>
      <span className="select-helper-text hide" id="helper-text-duration">
        Please select duration
      </span>
    </div>
  );
};
Feature.FilterName = ({ filters }) => {
  return (
    <div key="filter-name" className="filter-input-field">
      <TextInput
        placeholder=""
        id="filter-inp-name"
        name="name"
        label="Name Search"
      />
    </div>
  );
};
Feature.FilterEmail = ({ filters }) => {
  return (
    <div key="filter-email" className="filter-input-field">
      <TextInput
        placeholder=""
        id="filter-inp-email"
        name="email"
        label="Email Search"
      />
    </div>
  );
};
Feature.FilterStatus = ({ data, filters }) => {
  return (
    <div key="filter-status" className="filter-input-field select">
      <Select
        multiple={true}
        id="filter-inp-status"
        name="status"
        options={{
          classes: "",
          dropdownOptions: {
            alignment: "left",
            autoTrigger: true,
            closeOnClick: false,
            constrainWidth: true,
            coverTrigger: true,
            hover: false,
            inDuration: 150,
            onCloseEnd: null,
            onCloseStart: null,
            onOpenEnd: null,
            onOpenStart: null,
            outDuration: 250 } }}
        value={filters.status ?? []}
      >
        <Html.Options
          data={data}
          addon={{
            key: "status",
            name: "name",
            value: "code",
            title: "Leave Status" }}
        />
      </Select>
      <span className="select-helper-text hide" id="helper-text-status">
        Please select Status
      </span>
    </div>
  );
};
Feature.FilterLeaveType = ({ data, filters }) => {
  let itemData = [];
  let country = [];
  let n = 0;
  if ("country" in filters && filters.country.length > 0) {
    country = filters.country;
    n = country.length;
  }
  for (let name in data) {
    let values = data[name];
    if (n > 0) {
      let searchObj = Func.SearchObject(values, country, "country_code");
      if (Object.keys(searchObj).length > 0) {
        itemData.push({
          name: Func.HtmlDecode(name),
          value: values[0]["leavetype_code"] });
      }
    } else {
      itemData.push({
        name: Func.HtmlDecode(name),
        value: values[0]["leavetype_code"] });
    }
  }
  return (
    <div key="filter-leavetype" className="filter-input-field select">
      <Select
        multiple={true}
        id="filter-inp-leavetype"
        name="leavetype"
        options={{
          classes: "",
          dropdownOptions: {
            alignment: "left",
            autoTrigger: true,
            closeOnClick: false,
            constrainWidth: true,
            coverTrigger: true,
            hover: false,
            inDuration: 150,
            onCloseEnd: null,
            onCloseStart: null,
            onOpenEnd: null,
            onOpenStart: null,
            outDuration: 250 } }}
        value={filters.leavetype ?? []}
      >
        <Html.Options
          data={itemData}
          addon={{
            key: "leavetype",
            name: "name",
            value: "value",
            title: "Leave Type" }}
        />
      </Select>
      <span className="select-helper-text hide" id="helper-text-leavetype">
        Please select leavetype
      </span>
    </div>
  );
};
Feature.FilterDepartmentOneSelect = FilterDepartmentOneSelect;
Feature.FilterDivisionOneSelect = FilterDivisionOneSelect;

Feature.FilterLocation = ({ data, filters, userData }) => {
  let itemData = [];
  let searchObj = data;
  let n = 0;
  if ("country" in filters && filters.country.length > 0) {
    let country = filters.country;
    n = country.length;
    searchObj = Func.SearchObject(data, country, "country_code");
  }
  for (let i in searchObj) {
    let row = searchObj[i];
    if (n == 0 && row.country_code == "GROUP") continue;
    let name = "";
    if ("full_city" in row) {
      name = row.full_city;
    } else {
      name = row.city;
      if (n != 1) {
        name += " (" + row.country_code + ")";
      }
    }
    itemData.push({ name: name, value: row.city });
  }
  return (
    <div key="filter-location" className="filter-input-field select">
      <Select
        multiple={true}
        id="filter-inp-location"
        name="location"
        options={{
          classes: "",
          dropdownOptions: {
            alignment: "left",
            autoTrigger: true,
            closeOnClick: false,
            constrainWidth: true,
            coverTrigger: true,
            hover: false,
            inDuration: 150,
            onCloseEnd: null,
            onCloseStart: null,
            onOpenEnd: null,
            onOpenStart: null,
            outDuration: 250 } }}
        value={filters.location ?? []}
      >
        <Html.Options
          data={itemData}
          addon={{
            key: "location",
            name: "name",
            value: "value",
            title: "Location" }}
        />
      </Select>
      <span className="select-helper-text hide" id="helper-text-location">
        Please select location
      </span>
    </div>
  );
};
Feature.FilterCountry = ({ data, filters, handleEvents }) => {
  let country = "";
  if ("country" in filters && filters["country"].length > 0) {
    country = filters.country[0];
  }
  return (
    <div key="filter-country" className="filter-input-field select">
      <Select
        multiple={false}
        id="filter-inp-country"
        name="country"
        options={{
          classes: "",
          dropdownOptions: {
            alignment: "left",
            autoTrigger: true,
            closeOnClick: true,
            constrainWidth: true,
            coverTrigger: true,
            hover: false,
            inDuration: 150,
            onCloseEnd: null,
            onCloseStart: null,
            onOpenEnd: null,
            onOpenStart: null,
            outDuration: 250 } }}
        defaultValue={country}
        onChange={handleEvents.OnChange}
      >
        <Html.Options
          data={data}
          addon={{
            key: "country",
            name: "country_name",
            value: "country_code",
            title: "Country" }}
        />
      </Select>
      <span className="select-helper-text hide" id="helper-text-country">
        Please select country
      </span>
    </div>
  );
};

